import { IFeatureSection, ITierData, ITierHighlights } from "./types";
import { EPriceTabView } from "../../../../@types";

export const TIER_HIGHLIGHTS: ITierHighlights = {
  FREE: {
    sections: [
      {
        title: "Clips & Quality",
        items: [
          { text: "**5** clips per month", isComingSoon: true },
          { text: "**10** clips of cloud storage", isComingSoon: true },
          { text: "**720p** at **30fps** quality", isComingSoon: true },
        ],
      },
      {
        title: "Features",
        items: ["Add music to your clips"],
      },
    ],
  },
  ESSENTIALS: {
    sections: [
      {
        title: "Clips & Quality",
        items: [
          {
            text: "**10** clips per month",
            isComingSoon: true,
          },
          {
            text: "**50** clips of cloud storage",
            isComingSoon: true,
          },
          {
            text: "**1080p** at **60fps** for smooth playback",
            isComingSoon: true,
          },
        ],
      },
      {
        title: "Features",
        items: [
          "Download clips to your device",
          "Access to filters, effects & cameras",
        ],
      },
    ],
  },
  PRO: {
    sections: [
      {
        title: "Clips & Quality",
        items: [
          {
            text: "**50** clips per month",
            isComingSoon: true,
          },
          {
            text: "**500** clips of cloud storage",
            isComingSoon: true,
          },
          {
            text: "**1080p** at **120fps** for buttery smooth clips",
            isComingSoon: true,
          },
        ],
      },
      {
        title: "Features",
        items: [
          "**Timeline Editor** for precise control over clip creation",
          "Create squad, match and career montages",
          "Remove watermarks on your clips",
        ],
      },
    ],
  },
  CREATOR_PLAT: {
    sections: [
      {
        title: "Clips & Quality",
        items: [
          {
            text: "**Unlimited** clips – create as much as you want",
            isComingSoon: true,
          },
          {
            text: "**Unlimited** cloud storage for all your content",
            isComingSoon: true,
          },
          { text: "Stunning **4K** at up to **600fps**", isComingSoon: true },
        ],
      },
      {
        title: "Features",
        items: [
          {
            text: "**Priority** processing – skip the queue",
            isComingSoon: true,
          },
          "Access to every feature from Standard",
        ],
      },
    ],
  },
};

export const TIER_DATA: ITierData[] = [
  {
    key: "FREE",
    name: "Free",
    description: "Get started creating and sharing clips",
    pricing: {
      monthly: "Free",
      annual: "Free",
      annualTotal: "Free",
      discount: "",
    },
    stripeLookup: {
      [EPriceTabView.Monthly]: "",
      [EPriceTabView.Annual]: "",
    },
  },
  {
    key: "ESSENTIALS",
    name: "Basic",
    description: "More clips, downloads, and extra features",
    pricing: {
      monthly: "$0.99",
      annual: "$0.89",
      annualTotal: "$10.69/yr",
      discount: "Save 10%",
    },
    stripeLookup: {
      [EPriceTabView.Monthly]: "essentials_monthly",
      [EPriceTabView.Annual]: "essentials_yearly",
    },
  },
  {
    key: "PRO",
    name: "Standard",
    description: "Advanced editing for more serious creators",
    pricing: {
      monthly: "$5.99",
      annual: "$4.79",
      annualTotal: "$57.48/yr",
      discount: "Save 20%",
    },
    stripeLookup: {
      [EPriceTabView.Monthly]: "pro_monthly",
      [EPriceTabView.Annual]: "pro_yearly",
    },
  },
  {
    key: "CREATOR_PLAT",
    name: "Unlimited",
    description: "Unlimited clipping for professional creators",
    pricing: {
      monthly: "$14.99",
      annual: "$9.74",
      annualTotal: "$116.92/yr",
      discount: "Save 35%",
    },
    stripeLookup: {
      [EPriceTabView.Monthly]: "plat_monthly",
      [EPriceTabView.Annual]: "plat_yearly",
    },
  },
];

export const FEATURE_SECTIONS: IFeatureSection[] = [
  {
    title: "Clips & Storage",
    isComingSoon: true,
    features: [
      {
        name: "Clips per Month",
        free: "5",
        basic: "10",
        standard: "50",
        unlimited: "∞",
      },
      {
        name: "Cloud Storage",
        free: "10 Clips",
        basic: "50 Clips",
        standard: "500 Clips",
        unlimited: "∞",
      },
      {
        name: "Processing Speed",
        free: "Low",
        basic: "Standard",
        standard: "Fast",
        unlimited: "Priority",
      },
      {
        name: "Max Resolution",
        free: "720p",
        basic: "1080p",
        standard: "1080p",
        unlimited: "4K",
      },
      {
        name: "Max Frame Rate",
        free: "30 fps",
        basic: "60 fps",
        standard: "120 fps",
        unlimited: "600 fps",
      },
    ],
  },
  {
    title: "Features",
    features: [
      {
        name: "Download Clips",
        free: false,
        basic: true,
        standard: true,
        unlimited: true,
      },
      {
        name: "Auto Clipping",
        free: false,
        basic: false,
        standard: true,
        unlimited: true,
        isComingSoon: true,
      },
      {
        name: "Mobile Clips",
        free: false,
        basic: true,
        standard: true,
        unlimited: true,
      },
      {
        name: "Create Team",
        free: false,
        basic: false,
        standard: true,
        unlimited: true,
      },
    ],
  },
  {
    title: "Editing",
    features: [
      {
        name: "Add Music",
        free: true,
        basic: true,
        standard: true,
        unlimited: true,
      },
      {
        name: "Filters & FX",
        free: false,
        basic: true,
        standard: true,
        unlimited: true,
      },
      {
        name: "Cameras",
        free: false,
        basic: true,
        standard: true,
        unlimited: true,
      },
      {
        name: "Time Remap",
        free: false,
        basic: false,
        standard: true,
        unlimited: true,
      },
      {
        name: "Enemy POV",
        free: false,
        basic: false,
        standard: true,
        unlimited: true,
      },
    ],
  },
  {
    title: "Tools",
    features: [
      {
        name: "Montages",
        free: false,
        basic: true,
        standard: true,
        unlimited: true,
      },
      {
        name: "Timeline Editor",
        free: false,
        basic: false,
        standard: true,
        unlimited: true,
      },
      {
        name: "Remove Watermark",
        free: false,
        basic: false,
        standard: true,
        unlimited: true,
      },
    ],
  },
];

export const getTierFeatureValue = (
  tierName: string,
  feature: { free: any; basic: any; standard: any; unlimited: any },
) => {
  switch (tierName.toLowerCase()) {
    case "free":
      return feature.free;
    case "basic":
      return feature.basic;
    case "standard":
      return feature.standard;
    case "unlimited":
      return feature.unlimited;
    default:
      return feature.free;
  }
};
